import React from 'react';
import { ROTULO_ETAPA, type EtapaBoleto } from '../../../supabase/functions/_shared/etapaBoletoParcela.ts';

// Selo da situação do boleto da parcela (#6540), no mesmo desenho dos selos do
// cronograma de Parcelamentos. Âmbar = falta a equipe agir; vermelho = venceu.

const TOM: Record<EtapaBoleto, string> = {
    paga: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800',
    enviada: 'bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-900/20 dark:text-sky-300 dark:border-sky-800',
    a_enviar: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800',
    sem_boleto: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800',
    vencida: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-300 dark:border-red-800',
    no_boleto_mensal: 'bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-900/20 dark:text-indigo-300 dark:border-indigo-800',
    sem_fatura: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700',
    em_preparo: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700',
    cancelada: 'bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700',
};

/** `cedo`: boleto não emitido de parcela que ainda não entrou na janela de emissão
 *  (10 dias) — nada a fazer por enquanto, então sai neutro em vez de âmbar. */
const EtapaBoletoBadge: React.FC<{ etapa: EtapaBoleto; title?: string; cedo?: boolean }> = ({ etapa, title, cedo }) => (
    <span
        title={title}
        className={`inline-block whitespace-nowrap px-2 py-0.5 text-[10px] font-black uppercase tracking-wider border rounded ${cedo && etapa === 'sem_boleto' ? TOM.sem_fatura : TOM[etapa]}`}
    >
        {ROTULO_ETAPA[etapa]}
    </span>
);

export default EtapaBoletoBadge;
